import React, { Component } from 'react';

import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import TextField from '@material-ui/core/TextField';

import { SortableHandle } from 'react-sortable-hoc';
import { getFolderRef } from '../../../../config/firebase';
import { updateLastUpdatedTimestamp } from '../../../../utils';

const DragHandle = SortableHandle(() => <span className="sortable-handle">&#8942;&#8942;</span>);

class FolderListItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      title: this.props.folder.title,
      originalTitle: this.props.folder.title,
      deleting: false,
      editing: false,
      updateStatus: '',
    }

    this.handleChange = this.handleChange.bind(this)
    this.handleEdit = this.handleEdit.bind(this)
    this.handleSave = this.handleSave.bind(this)
    this.handleCancel = this.handleCancel.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    // We don't have to do this check first, but it can help prevent an unneeded render
    if (nextProps.folder.title !== this.state.title) {
      this.setState({ title: nextProps.folder.title });
    }
  }

  handleChange(event) {
    let title = event.target.value;
    this.setState({title});
  }

  handleEdit() {
    this.setState({ editing: true, originalTitle: this.state.title });
  }

  handleSave() {
    let title = this.state.title.trim();

    if (!title) {
      return;
    }

    getFolderRef(this.props.folder.id).update({ title }, (result) => {
      updateLastUpdatedTimestamp();
      this.setState({ updateStatus: 'saved' });
    });

    this.setState({
      updateStatus: 'saving',
      editing: false
    });
  }

  handleCancel() {
    this.setState({ editing: false, title: this.state.originalTitle });
  }

  render() {
    const titleEl = !this.state.editing
      ? <span>{this.state.title}</span>
      : null;

    const titleEditor = this.state.editing
      ? (
        <TextField
          fullWidth
          label=""
          name="title"
          value={this.state.title}
          onChange={this.handleChange}
          margin="none"
          />
      )
      : null;

    const editButton = !this.state.editing
      ? (
        <IconButton color="primary" onClick={this.handleEdit}>
          <Icon>edit</Icon>
        </IconButton>
      )
      : null;

    const deleteButton = !this.state.editing
      ? (
        <IconButton color="secondary" onClick={() => this.props.conformDelete(this.props.folder)}>
          <Icon>delete</Icon>
        </IconButton>
      )
      : null;

    const saveButton = this.state.editing
      ? (
        <IconButton onClick={this.handleSave}>
          <Icon>done</Icon>
        </IconButton>
      )
      : null;

    const cancelButton = this.state.editing
      ? (
        <IconButton onClick={this.handleCancel}>
          <Icon>clear</Icon>
        </IconButton>
      )
      : null;

    return (
      <ListItem className="folder-list-item" divider>
        <DragHandle />
        <ListItemText>
          {titleEl}
          {titleEditor}
        </ListItemText>
        <ListItemSecondaryAction>
          {editButton}
          {deleteButton}
          {saveButton}
          {cancelButton}
        </ListItemSecondaryAction>
      </ListItem>
    )
  }
}

export default FolderListItem;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/FolderListItem/index.js